import { motion } from "framer-motion";

/**
 * Page-to-page transition wrapper — used by every route's element prop.
 * "Push" feel: outgoing slides up and fades out, incoming rises from below
 * and fades in. Smooth, continuous-app vibe (Stripe/Linear inspired, applied
 * with Ruben Stom's push-pull motion language).
 */
const variants = {
  initial: { opacity: 0, y: 28, filter: "blur(6px)" },
  enter:   { opacity: 1, y: 0,  filter: "blur(0px)" },
  exit:    { opacity: 0, y: -22, filter: "blur(4px)" },
};

export default function PageTransition({ children, testid }) {
  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="enter"
      exit="exit"
      transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testid || "page-transition"}
    >
      {children}
    </motion.div>
  );
}
